// @flow
import React from "react";
import type {GroupMember} from "../../models/GroupMember";
import type {translate} from "../../i18next";
import "./LocationChoiceField.scss";

export const LOCATION_FIELD = "location";

export type LocationChoiceFieldProps = {
    locationChoices: ?GroupMember[],
    pickupLocation: ?GroupMember,
    isShopEnabled: boolean,
    register: (name: string, options?: Object) => Object,
    hasError: boolean,
    t: translate,
};

const describe = (location: GroupMember) => {
    const address = location.address || {};
    const place = [address.postalCode, address.town].filter(Boolean).join(" ");
    return place ? `${location.name}, ${place}` : location.name;
};

/**
 * Names the group location a lead (product enquiry, wishlist) is meant for. A shop module
 * keeps the pickup location the customer already chose, because changing it would clear
 * the cart. Every other group module offers the list and insists on a choice.
 * Renders nothing outside group modules.
 */
const LocationChoiceField = (props: LocationChoiceFieldProps) => {
    if (!props.locationChoices || props.locationChoices.length === 0) {
        return null;
    }
    const keepsPickupLocation = props.isShopEnabled && props.pickupLocation;

    return <tr>
        <td colSpan="2" className={`hpm-locationChoice${props.hasError ? " hpm-error" : ""}`}>
            <label htmlFor="hpm-lead-location" className="hpm-label">{props.t("feedback.preferredLocation")}</label>
            {keepsPickupLocation
                ? <React.Fragment>
                    <input type="hidden" {...props.register(LOCATION_FIELD)}/>
                    {/* <output> is labelable, so the label above stays valid for the fixed location too */}
                    <output id="hpm-lead-location" className="hpm-locationChoice-selected">
                        {describe(props.pickupLocation)}
                    </output>
                </React.Fragment>
                : <select id="hpm-lead-location"
                          aria-invalid={props.hasError}
                          {...props.register(LOCATION_FIELD, {required: true})}>
                    <option value="">{props.t("location.select")}</option>
                    {props.locationChoices.map(location =>
                        <option key={location.cfgKey} value={location.cfgKey}>{describe(location)}</option>
                    )}
                </select>
            }
        </td>
    </tr>;
};

export default LocationChoiceField;
